module.exports = __webpack_public_path__ + "static/media/idlepage.fe9b5b71.svg";